<template>
  <div>
    <div>
      <el-dialog
        :title="mainTitle"
        :visible.sync="editVisible"
        width="600px"
        @close="closeEdit"
        @open="dlgOpen"
        @closed="dlgClosed"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
      >
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" v-loading="loading">
          <el-form-item label="系统分类" prop="systemId">
            <el-select
              v-model.trim="form.systemId"
              placeholder="请选择系统分类"
              style="width:90%"
              clearable
            >
              <el-option
                v-for="item in systemData"
                :key="item.value"
                :label="item.key"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="组织名称" prop="parentName">
            <el-input
              v-model.trim="form.parentName"
              placeholder="请选择组织名称"
              v-on:click.native="openElTreeDialog"
              style="width:90%"
            ></el-input>
          </el-form-item>
          <el-form-item label="机构名称" prop="name">
            <el-input
              v-model.trim="form.name"
              autocomplete="off"
              placeholder="请输入机构名称"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>

          <el-form-item label="负责人" prop="principal">
            <el-input
              v-model.trim="form.principal"
              placeholder="请输入负责人"
              clearable
              style="width:90%"
            ></el-input>
          </el-form-item>

          <el-form-item label="联系电话" prop="phone">
            <el-input v-model.trim="form.phone" placeholder="请输入联系电话" clearable style="width:90%"></el-input>
          </el-form-item>

          <el-form-item label="省市区" prop="mobile">
            <el-select
              v-model.trim="provinceValue"
              @change="choseProvince"
              placeholder="省级地区"
              style="width:38%"
              clearable
            >
              <el-option
                v-for="item in provinceData"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-select
              v-model.trim="cityValue"
              @change="choseCity"
              placeholder="市级地区"
              style="width:30%"
              clearable
            >
              <el-option
                v-for="item in cityData"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
            <el-select
              v-model.trim="areaValue"
              @change="choseBlock"
              placeholder="区级地区"
              style="width:25%"
              clearable
            >
              <el-option
                v-for="item in areaData"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细街道" prop="address">
            <el-input v-model.trim="form.address" placeholder="请输入详细街道" clearable style="width:90%"></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="disabled">
            <el-radio v-model="form.disabled" label="0">正常</el-radio>
            <el-radio v-model="form.disabled" label="1">禁用</el-radio>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="resetForm('form')">取 消</el-button>
          <el-button type="primary" @click="onSubmit('form')" :disabled="btnDisabled">确 定</el-button>
        </span>
      </el-dialog>
    </div>

    <OrganizationDlg
      v-if="organizationDlgShow"
      @node-data="handleCallData"
      ref="organizationDlgRef"
    ></OrganizationDlg>
  </div>
</template>
<script>
import DialogResize from "@/utils/DialogResize.js";
import OrganizationDlg from "./OrganizationDlg.vue";
import SettingApi from "@/api/setting.js";
export default {
  mixins: [DialogResize],
  components: {
    OrganizationDlg
  },
  data() {
    return {
      systemData: [],
      provinceValue: "",
      cityValue: "",
      areaValue: "",
      provinceData: [],
      cityData: [],
      areaData: [],
      operateFlag: "",
      mainTitle: "",
      showParentId: "",
      nowParentId: "",
      oldDisabled: "",
      editVisible: false,
      btnDisabled: false,
      loading: false,
      organizationDlgShow: false,
      form: {
        cardMode: [],
        areaCode: "",
        parentName: "",
        parentId: "",
        name: "",
        level: "",
        principal: "",
        phone: "",
        address: "",
        remark: "",
        systemId: "",
        disabled: ""
      },
      rules: {
        systemId: [
          { required: true, message: "系统分类不能为空", trigger: "change" }
        ],
        parentName: [
          { required: true, message: "组织名称不能为空", trigger: "change" }
        ],
        name: [
          { required: true, message: "机构名称不能为空", trigger: "change" },
          {
            min: 1,
            max: 200,
            message: "机构名称输入不能超过200个字符，请重新输入",
            trigger: "blur"
          }
        ],
        principal: [
          { required: true, message: "负责人不能为空", trigger: "change" },
          {
            min: 1,
            max: 30,
            message: "负责人输入不能超过30个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
            message: "不允许输入空格等特殊符号"
          }
        ],
        phone: [
          { required: true, message: "联系电话不能为空", trigger: "change" },
          {
            validator: function(rule, value, callback) {
              if (value != null && value != "") {
                if (/^1[3456789]\d{9}$/.test(value) == false) {
                  callback(new Error("请输入正确的手机号"));
                } else {
                  callback();
                }
              } else {
                return callback();
              }
            }
          }
        ],
        address: [
          { required: false, message: "详细地址不能为空", trigger: "change" },
          {
            min: 1,
            max: 150,
            message: "详细地址输入不能超过150个字符，请重新输入",
            trigger: "blur"
          },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
            message: "不允许输入空格等特殊符号"
          }
        ]
        // systemId: [
        //   { required: false, message: "系统ID不能为空", trigger: "change" }
        // ]
        // cardMode: [
        //   { required: true, message: "打卡方式不能为空", trigger: "change" }
        // ]
      }
    };
  },
  methods: {
    init(param, row, operateFlag) {
      this.loading = false;
      this.btnDisabled = false;
      this.initProvinceData();
      this.initSystemData();
      this.showParentId = param.parentId;
      this.nowParentId = param.parentId;
      this.provinceValue = "";
      this.cityData = [];
      this.cityValue = "";
      this.areaData = [];
      this.areaValue = "";
      if (operateFlag == "add") {
        this.mainTitle = "新增公司";
        this.operateFlag = "add";
        this.form = {
          parentId: param.parentId,
          parentName: param.parentName,
          id: "",
          name: "",
          principal: "",
          phone: "",
          address: "",
          areaCode: "",
          cardMode: "",
          disabled: "0"
        };
      }
      if (operateFlag == "update") {
        this.mainTitle = "编辑公司";
        this.operateFlag = "update";
        this.getOrganizationById(row.id);
      }
      this.editVisible = true;
    }, //清空表单验证
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.parentName = "";
      this.form.parentId = "";
      this.editVisible = false;
    },
    openElTreeDialog() {
      this.organizationDlgShow = true;
      this.$nextTick(() => {
        // type 必传 0表示全部的组织架构 每个都可以选 1表示公司 2表示部门
        // id  可选  传入id可以默认选中当前传入的id节点 如果不需要默认选中 就传null
        this.$refs.organizationDlgRef.init(1, this.showParentId, null);
      });
    },
    handleCallData(nodeData) {
      this.form.parentName = nodeData.name;
      this.form.parentId = nodeData.id;
    },
    closeEdit() {
      this.$refs["form"].resetFields();
      this.form.parentName = "";
      this.form.parentId = "";
    },
    choseProvince: function(e) {
      this.provinceValue = e;
      if (e && e != "") {
        this.initCityData(e, true);
      } else {
        this.cityData = [];
        this.cityValue = "";
        this.areaData = [];
        this.areaValue = "";
      }
    },
    // 选市
    choseCity: function(e) {
      this.cityValue = e;
      if (e && e != "") {
        this.initAreaData(e, true);
      } else {
        this.areaData = [];
        this.areaValue = "";
      }
    },
    // 选区
    choseBlock: function(e) {
      this.areaValue = e;
    },
    // 初始化省级数据
    initProvinceData() {
      // this.$mhttp
      //   .httpGet(this.$constant.API_NSC + "uc/area/findAreaVoList", null, null)
      SettingApi.getClass()
        .initProvinceData()
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.provinceData = res2.data.data.provinces;
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    // 初始化市级数据
    initCityData(parentKey, flag) {
      let param = {
        parentKey: parentKey
      };
      // this.$mhttp.httpGet(
      //   this.$constant.API_NSC + "uc/area/findByParentKey",
      //   param,
      //   null
      // );

      SettingApi.getClass()
        .initCityData(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.cityData = [];
            for (let i = 0; i < data.length; i++) {
              obj = {
                value: data[i].value,
                key: data[i].key
              };
              this.cityData.push(obj);
            }
            if (flag == true) {
              this.cityValue = this.cityData[0].key;
              this.initAreaData(data[0].key, flag);
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    // 初始化区级数据
    initAreaData(parentKey, flag) {
      let param = {
        parentKey: parentKey
      };
      // this.$mhttp.httpGet(
      //   this.$constant.API_NSC + "uc/area/findByParentKey",
      //   param,
      //   null
      // );

      SettingApi.getClass()
        .initAreaData(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.areaData = [];
            for (let i = 0; i < data.length; i++) {
              obj = {
                value: data[i].value,
                key: data[i].key
              };
              this.areaData.push(obj);
            }
            if (flag == true) {
              this.areaValue = this.areaData[0].key;
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true;
          this.btnDisabled = true;
          var v = this.form;
          let areaParam = "";

          if (
            this.provinceData.length != 0 &&
            this.provinceValue &&
            this.provinceValue != ""
          ) {
            if (
              this.cityData.length != 0 &&
              this.cityValue &&
              this.cityValue != ""
            ) {
              if (
                this.areaData.length != 0 &&
                this.areaValue &&
                this.areaValue != ""
              ) {
                areaParam = this.areaValue;
              } else {
                areaParam = this.cityValue;
              }
            } else {
              areaParam = this.provinceValue;
            }
          } else {
            areaParam = "";
          }
          let param = {};
          param = {
            level: 1,
            parentId: v.parentId,
            id: v.id,
            name: v.name,
            principal: v.principal,
            phone: v.phone,
            address: v.address,
            areaCode: areaParam,
            systemId: v.systemId,
            disabled: v.disabled
          };

          if (
            this.oldDisabled != this.form.disabled &&
            this.form.disabled == "1"
          ) {
            this.$confirm(
              "禁用公司或部门，下级也会被禁用，同时该公司或部门下人员将无法登录，确认操作?",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "info"
              }
            )
              .then(() => {
                console.log(this.form.disabled);
                console.log(this.form.disabled == this.oldDisabled);
                this.saveCompany(param, v.id);
              })
              .catch(() => {
                this.loading = false;
                this.btnDisabled = false;
              });
          } else {
            this.saveCompany(param, v.id);
          }
        } else {
          this.loading = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    saveCompany(param, id) {
      SettingApi.getClass()
        .saveOrg(param)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.$message.success("保存成功！");
            this.loading = false;
            this.btnDisabled = false;
            //关闭弹窗
            this.editVisible = false;
            //刷新左边树的数据
            // this.onloadGroup(false);
            if (id != null && id != "" && id != undefined) {
              this.$parent.refreshTree("edit");
            } else {
              this.$parent.refreshTree("add");
            }
            //刷新右边列表数据
            this.$parent.getListData(this.nowParentId);
          } else {
            this.loading = false;
            this.btnDisabled = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.btnDisabled = false;
          this.$message.error(err);
          return false;
        });
    },
    getOrganizationById(id) {
      // this.$mhttp.httpGet(this.$constant.API_NSC + "uc/dept/" + id, null, null);
      this.loading = true;
      this.btnDisabled = true;
      SettingApi.getClass()
        .getOrgById(id)
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            this.loading = false;
            this.btnDisabled = false;
            let data = res2.data.data;
            this.oldDisabled = data.disabled;
            this.form = {
              parentId: data.parentId,
              parentName: data.parentName,
              id: data.id,
              name: data.name,
              principal: data.principal,
              phone: data.phone,
              address: data.address,
              cardMode: data.cardMode,
              systemId: data.systemId,
              disabled: data.disabled + ""
            };
            if (data.areaKeys && data.areaKeys != "") {
              let areaKeys = data.areaKeys;
              let areaArr = areaKeys.split(",");
              for (let i = 0; i < areaArr.length; i++) {
                this.provinceValue = areaArr[0];
                this.cityValue = areaArr[1];
                this.areaValue = areaArr[2];
              }
              //如果省市区其中有值
              if (this.provinceValue && this.provinceValue != "") {
                this.initCityData(areaArr[0], false);
              }
              if (this.cityValue && this.cityValue != "") {
                this.initAreaData(areaArr[1], false);
              }
            }
          } else {
            this.loading = false;
            this.btnDisabled = false;
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.loading = false;
          this.btnDisabled = false;
          this.$message.error(err);
          return false;
        });
    },
    initSystemData() {
      // this.$mhttp.httpGet(
      //   this.$constant.API_NSC + "uc/system/systems",
      //   null,
      //   null
      // );

      SettingApi.getClass()
        .loadSystems()
        .then(res2 => {
          if (this.$constant.BIZ_RESPONSE_CODE == res2.data.code) {
            let data = res2.data.data;
            let obj = {};
            this.systemData = [];
            for (let i = 0; i < data.length; i++) {
              obj = {
                value: data[i].id + "",
                key: data[i].name
              };
              this.systemData.push(obj);
            }
          } else {
            this.$message.error(res2.data.msg);
            return false;
          }
        })
        .catch(err => {
          this.$message.error(err);
          return false;
        });
    }
  }
};
</script>
<style scoped>
</style>
